export default "__VITE_ASSET__C7CG3WZA__"